module.exports = __webpack_public_path__ + "img/矩形-暗.87ca2878.png";